import type { Alignment } from './index';

const FLEX: Record<Alignment, string> = {
    L: 'flex-start',
    T: 'flex-start',
    left: 'flex-start',
    top: 'flex-start',
    M: 'center',
    center: 'center',
    middle: 'center',
    R: 'flex-end',
    B: 'flex-end',
    right: 'flex-end',
    bottom: 'flex-end',
};

const TEXT: Partial<Record<Alignment, string>> = {
    L: 'left',
    left: 'left',
    M: 'center',
    center: 'center',
    R: 'right',
    right: 'right',
};

/** `flex-start | center | flex-end` for any alignment spelling — `justify-content` or `align-items`. */
export function flexAlignVar(align: unknown, fallback = ''): string {
    return FLEX[align as Alignment] ?? fallback;
}

/** `left | center | right` for a horizontal alignment spelling. */
export function textAlignVar(align: unknown, fallback = ''): string {
    return TEXT[align as Alignment] ?? fallback;
}
